import * as React from "react";
import { useMediaQuery } from "react-responsive";
import { Button } from "../../button/button.mjs";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
import { media } from "../../helpers/theme-provider/theme-provider.mjs";
import { ModalCloser } from "../modal-closer/modal-closer.mjs";
const ModalHeader = (props) => {
  const isMobile = useMediaQuery({ maxWidth: media.width.sm.max });
  const { className, theme, children, backButton } = props;
  const BEM = () => {
    const classArray = ["modal__header"];
    if (theme) {
      classArray.push("modal__header--".concat(theme));
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const renderWithBackButton = (backButton2) => /* @__PURE__ */ React.createElement(Grid, { noWrap: true, verticalGutter: "none", align: ["middle-xs"] }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"] }, /* @__PURE__ */ React.createElement(ModalCloser, null, /* @__PURE__ */ React.createElement(Button, { ...backButton2, variant: "secondary", icon: "#arrow-left", theme }))), /* @__PURE__ */ React.createElement(GridColumn, { width: ["max"] }, children));
  return /* @__PURE__ */ React.createElement("div", { className: BEM(), "data-theme": theme }, backButton && isMobile ? renderWithBackButton(backButton) : children);
};
export {
  ModalHeader
};
